const logger = store => next => action => {
    try{
        let result = null;
        console.group(action.type)
        console.info('dispatching', action);
        result = next(action)
        console.log('next state', store.getState())
        console.groupEnd()
        return result
    }catch(err){
        console.log("err::", err);
    }
}
  
export default logger